<template>
  <div class="form-row">
    <div class="form-group col-sm-5" :class="group_class">
      <label for="county">地址</label>
      <select
        id="county"
        class="custom-select rounded-0"
        v-model="child.city_id"
        :class="{ 'is-invalid': state === false }"
        :disabled="readonly"
      >
        <option :value="undefined || ''" selected disabled>請選擇</option>
        <option v-for="val in TW_city_town" :key="val.id" :value="val.id">{{
          val.city_name
        }}</option>
      </select>
    </div>
    <div class="form-group col-sm-4">
      <label
        for="town"
        style="visibility: hidden;"
        class="d-none d-sm-inline-block"
        >選擇鄉鎮區</label
      >
      <select
        id="town"
        class="custom-select  rounded-0"
        v-model="child.town_id"
        :class="{ 'is-invalid': state === false }"
        :disabled="readonly"
      >
        <option :value="undefined || ''" selected disabled>請選擇</option>
        <template v-if="child.city_id">
          <option
            v-for="val in TW_city_town[cityIndex].towns"
            :key="val.id"
            :value="val.id"
            >{{ val.town_name }}</option
          >
        </template>
      </select>
    </div>
    <div class="form-group col-sm-3">
      <label
        for="code"
        style="visibility: hidden;"
        class="d-none d-sm-inline-block"
        >區域號碼</label
      >
      <input
        type="text"
        id="code"
        class="form-control rounded-0"
        :value="child.postcode"
        readonly
        :class="{ 'is-invalid': state === false }"
      />
    </div>
    <div class="form-group col-md-12">
      <input
        type="text"
        id="address"
        class="form-control rounded-0"
        v-model="child.address"
        :class="{ 'is-invalid': state === false }"
        placeholder="地址"
        :readonly="readonly"
      />
      <div v-if="state === false" class="invalid-feedback">
        請填寫完整地址
      </div>
    </div>
  </div>
</template>
<script>
import { getZone } from "@/assets/api.config.js";
import { Toast } from "@/plugins/sweetalert2.js";

export default {
  name: "TWCityTown",
  props: ["town_id", "address", "state", "group_class", "readonly"],
  data() {
    return {
      TW_city_town: null,
      isUseTown_id: 1,
      child: {
        city_id: "",
        town_id: "",
        postcode: "",
        address: this.address
      }
    };
  },
  created() {
    getZone()
      .then(res => {
        if (res.status <= 201) {
          this.TW_city_town = res.data;
          this.TW_city_town.forEach(city => {
            city.towns.forEach(town => {
              if (town.id == this.town_id) {
                this.child.city_id = city.id;
              }
            });
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "地區資料下載失敗",
            text: res.data.error
          });
        }
      })
      .catch(err => {
        console.error(err);
      });
  },
  computed: {
    cityIndex() {
      let city_index = null;
      this.TW_city_town.forEach((val, index) => {
        if (val.id == this.child.city_id) {
          return (city_index = index);
        }
      });
      return city_index;
    },
    completeAddress() {
      const cityName = this.TW_city_town[this.cityIndex].city_name;
      let townName = "";

      this.TW_city_town[this.cityIndex].towns.forEach(val => {
        if (val.id == this.child.town_id) {
          townName = val.town_name;
        }
      });
      return (
        this.child.postcode + cityName + townName + (this.child.address || "")
      );
    }
  },
  watch: {
    town_id(val) {
      if (!this.TW_city_town) return;
      this.TW_city_town.forEach(city => {
        city.towns.forEach(town => {
          if (town.id == val) {
            this.child.city_id = city.id;
          }
        });
      });
    },
    address(val) {
      this.child.address = val;
    },
    child: {
      handler: function() {
        if (!this.isUseTown_id) {
          this.$emit("childMethod", {
            city_id: this.child.city_id,
            town_id: this.child.town_id,
            address: this.child.address,
            zone: this.getZone(this.TW_city_town[this.cityIndex].city_name),
            complete_address: this.completeAddress
          });
        }
      },
      deep: true
    },
    "child.city_id": function() {
      if (this.isUseTown_id) {
        this.isUseTown_id = 0;
        this.child.town_id = this.town_id || "";
        this.child.postcode = "";
        return;
      }
      this.child.town_id = "";
      this.child.postcode = "";
    },
    "child.town_id": function(val) {
      if (val !== "") {
        this.TW_city_town[this.cityIndex].towns.forEach(item => {
          if (val === item.id) {
            this.child.postcode = item.postcode;
            return;
          }
        });
      }
    }
  },
  methods: {
    getZone(city_name) {
      if (
        city_name.includes("臺北") ||
        city_name.includes("台北") ||
        city_name.includes("新北") ||
        city_name.includes("基隆") ||
        city_name.includes("桃園") ||
        city_name.includes("新竹") ||
        city_name.includes("苗栗")
      ) {
        return 1;
      } else if (
        city_name.includes("臺中") ||
        city_name.includes("台中") ||
        city_name.includes("彰化") ||
        city_name.includes("南投")
      ) {
        return 2;
      } else if (
        city_name.includes("雲林") ||
        city_name.includes("嘉義") ||
        city_name.includes("臺南") ||
        city_name.includes("台南") ||
        city_name.includes("高雄") ||
        city_name.includes("屏東")
      ) {
        return 3;
      } else if (
        city_name.includes("宜蘭") ||
        city_name.includes("花蓮") ||
        city_name.includes("臺東") ||
        city_name.includes("台東")
      ) {
        return 4;
      } else {
        return 5;
      }
    }
  }
};
</script>
